import { render, staticRenderFns } from "./SearchBarView.vue?vue&type=template&id=83c624b4&"
import script from "./SearchBarView.vue?vue&type=script&lang=js&"
export * from "./SearchBarView.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarView.vue?vue&type=style&index=0&id=83c624b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports